import React from 'react';
import {
    Card,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Table,
    Container,
    Row

} from 'reactstrap';
import RowData from './RowData';
import TablePagination from 'commonComponents/TablePagination';

// Component for Table details with header
const TableRoot = ({
    header,
    tableData,
    handleEdit,
    handleDelete,
    handleView,
    currentPage,
    totalPages,
    handlePageChange,
    setRowsPerPage,
    roweperpage
}) => {
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 2) {
            // If total pages are 2 or less, show all pages
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show current page with one previous and one next page if possible
            if (currentPage === 1) {
                pages.push(currentPage, currentPage + 1);
            } else if (currentPage === totalPages) {
                pages.push(currentPage - 1, currentPage);
            } else {
                pages.push(currentPage - 1, currentPage, currentPage + 1);
            }
        }
        return pages;
    };

    const pageNumbers = getPageNumbers();

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        const newTotalPages = Math.ceil(tableData.length / newRowsPerPage);
        if (currentPage > newTotalPages) {
          handlePageChange(1);
        }
      };

    return (
        <>
            <Container fluid>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <Table className="align-items-center table-flush" responsive>
                                <thead className="thead-light">
                                    <tr>
                                        {
                                            header.map((item, index) => (
                                                <th scope="col" key={index} className="align-items-center text-center" >{item}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                {tableData.map((item, index) => (
                                    <RowData key={index} itemInfo={item} handleEdit={handleEdit} handleDelete={handleDelete} handleView={handleView} index={index} />
                                ))}
                            </Table>

                            <CardFooter className="py-4 ">
                                {/* <div className='mr-auto'>
                                    <Input
                                        type="select"
                                        name="roweperpage"
                                        id="roweperpage"
                                        value={roweperpage}
                                        onChange={(e) => setRowsPerPage(e.target.value)}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                    </Input>
                                </div> */}
                                {/* <nav aria-label="...">
                                    <Pagination className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                                        {totalPages > 1 ? (
                                            <>
                                                <PaginationItem disabled={currentPage === 1}>
                                                    <PaginationLink
                                                        first
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handlePageChange(1);
                                                        }}
                                                    />
                                                </PaginationItem>
                                                <PaginationItem disabled={currentPage === 1}>
                                                    <PaginationLink
                                                        previous
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (currentPage > 1) handlePageChange(currentPage - 1);
                                                        }}
                                                    />
                                                </PaginationItem>

                                                <PaginationItem active>
                                                    <PaginationLink
                                                        href="#"
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        {currentPage}
                                                    </PaginationLink>
                                                </PaginationItem>

                                                <PaginationItem disabled={currentPage === totalPages}>
                                                    <PaginationLink
                                                        next
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (currentPage < totalPages) handlePageChange(currentPage + 1);
                                                        }}
                                                    />
                                                </PaginationItem>
                                                <PaginationItem disabled={currentPage === totalPages}>
                                                    <PaginationLink
                                                        last
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handlePageChange(totalPages);
                                                        }}
                                                    />
                                                </PaginationItem>
                                            </>
                                        ) : (
                                            <PaginationItem active>
                                                <PaginationLink href="#" onClick={(e) => e.preventDefault()}>
                                                    1
                                                </PaginationLink>
                                            </PaginationItem>
                                        )}
                                    </Pagination>
                                </nav> */}

                                <TablePagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    handlePageChange={handlePageChange}
                                    rowsPerPage={roweperpage}
                                    // setRowsPerPage={setRowsPerPage}
                                    setRowsPerPage={handleRowsPerPageChange}
                                />
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
};

export default TableRoot;


